import Checkbox from './checkbox';
import CheckboxGroup from './checkbox-group';

Checkbox.CheckboxGroup = CheckboxGroup;
export default Checkbox;
